module.exports = __webpack_public_path__ + "img/logo-text-color.99f2cafe.png";